export default {
  headerName: 'Nome',
  headerClientId: 'ID do Cliente',
  headerDateCreated: 'Data de criação',
  headerRetries: 'Tentativas',
  headerActions: 'Ações',
  chipAbandoned: 'abandonado',
  tooltipAbandonedRetries: 'Abandonado após {count} tentativas. Não será tentado novamente; reinicie-o quando a causa estiver resolvida.',
  // Indexado pelo código que reportSpawnFailure grava para um erro que tentar novamente não resolve.
  abandonedReasons: {
    missing_boot_image: 'A família de imagem de inicialização que este modelo pede não existe neste projeto, e nenhuma nova tentativa resolve isso. Reinicie-o quando a família de imagem for criada ou a configuração do modelo for corrigida.'
  },
  tooltipRestart: 'Reiniciar',
  tooltipDelete: 'Excluir',
  dialogWarningTitle: 'Aviso',
  dialogDeleteMessage: 'O documento de simulação foi excluído pelo usuário. Deseja excluir o documento da fila?',
  dialogDeleting: 'Excluindo:',
  dialogConfirmMessage: 'Esta ação não pode ser desfeita. Tem certeza?',
  dialogCancel: 'Cancelar',
  dialogDelete: 'Excluir',
  snackTryingRestart: 'Tentando reiniciar plano',
  snackPlanRestarted: 'Plano pendente reiniciado',
  snackDeletingPlan: 'Excluindo plano',
  snackPlanDeleted: 'Plano excluído'
}
